import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import YouTube from "react-youtube";

function MyProjects() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [show4, setShow4] = useState(false);
  const handleShow4 = () => setShow4(true);
  const handleClose4 = () => setShow4(false);

  const [show5, setShow5] = useState(false);
  const handleShow5 = () => setShow5(true);
  const handleClose5 = () => setShow5(false);

  const [show6, setShow6] = useState(false);
  const handleShow6 = () => setShow6(true);
  const handleClose6 = () => setShow6(false);

  const [show7, setShow7] = useState(false);
  const handleShow7 = () => setShow7(true);
  const handleClose7 = () => setShow7(false);

  const [showNiyam, setShowNiyam] = useState(false);
  const handleShowNiyam = () => setShowNiyam(true);
  const handleCloseNiyam = () => setShowNiyam(false);

  const [showNiyamTech, setShowNiyamTech] = useState(false);
  const handleShowNiyamTech = () => setShowNiyamTech(true);
  const handleCloseNiyamTech = () => setShowNiyamTech(false);

  const [showCPE, setShowCPE] = useState(false);
  const handleShowCPE = () => setShowCPE(true);
  const handleCloseCPE = () => setShowCPE(false);

  const [showCPETech, setShowCPETech] = useState(false);
  const handleShowCPETech = () => setShowCPETech(true);
  const handleCloseCPETech = () => setShowCPETech(false);

  const [showStoryteller, setShowStoryteller] = useState(false);
  const handleShowStoryteller = () => setShowStoryteller(true);
  const handleCloseStoryteller = () => setShowStoryteller(false);

  const [showStorytellerTech, setShowStorytellerTech] = useState(false);
  const handleShowStorytellerTech = () => setShowStorytellerTech(true);
  const handleCloseStorytellerTech = () => setShowStorytellerTech(false);

  const [showAIExplainer, setShowAIExplainer] = useState(false);
  const handleShowAIExplainer = () => setShowAIExplainer(true);
  const handleCloseAIExplainer = () => setShowAIExplainer(false);

  const [showAIExplainerTech, setShowAIExplainerTech] = useState(false);
  const handleShowAIExplainerTech = () => setShowAIExplainerTech(true);
  const handleCloseAIExplainerTech = () => setShowAIExplainerTech(false);

  const [showWexaTech, setShowWexaTech] = useState(false);
  const handleShowWexaTech = () => setShowWexaTech(true);
  const handleCloseWexaTech = () => setShowWexaTech(false);

  const [showCapitalAI, setShowCapitalAI] = useState(false);
  const handleShowCapitalAI = () => setShowCapitalAI(true);
  const handleCloseCapitalAI = () => setShowCapitalAI(false);

  const [showCapitalAITech, setShowCapitalAITech] = useState(false);
  const handleShowCapitalAITech = () => setShowCapitalAITech(true);
  const handleCloseCapitalAITech = () => setShowCapitalAITech(false);

  return (
    <div className="pro">
      <h1 className="headP">Projects</h1>

      <div className="projects my-4">
        {/* ---------------------- Unravel Video ---------------------- */}
        <Modal size="lg" show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title className="proj-video">Unravel</Modal.Title>
          </Modal.Header>
          <Modal.Body className="myVideo">
            <YouTube videoId="3NJ02IGTC90" className="project-youtube" />
          </Modal.Body>
        </Modal>

        {/* ---------------------- Connect Video ---------------------- */}
        <Modal size="lg" show={show1} onHide={handleClose1} centered>
          <Modal.Header closeButton>
            <Modal.Title className="proj-video">Connect</Modal.Title>
          </Modal.Header>
          <Modal.Body className="myVideo">
            <YouTube videoId="hxk4JW5kvI4" className="project-youtube" />
          </Modal.Body>
        </Modal>

        {/* ---------------------- Unravel Tech ---------------------- */}
        <Modal show={show2} onHide={handleClose2} centered>
          <Modal.Header closeButton>
            <Modal.Title>Unravel</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <b>Description:</b> Unravel is a dynamic social media platform
              dedicated to fostering connections among individuals with shared
              interests.
            </h6>
            <h6 className="mt-3">
              <b>Technology Stack:</b>
            </h6>
            <h6>
              <b>Backend:</b> Django, Django Rest Framework
            </h6>
            <h6>
              <b>Frontend:</b> HTML, CSS, Bootstrap, JavaScript
            </h6>
            <h6>
              <b>Database:</b> SQLite3
            </h6>
            <h6>
              <b>Visualization:</b> Plotly
            </h6>
          </Modal.Body>
        </Modal>

        {/* ---------------------- Connect Tech ---------------------- */}
        <Modal show={show3} onHide={handleClose3} centered>
          <Modal.Header closeButton>
            <Modal.Title>Connect</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <b>Description:</b> Connect is a dynamic social media platform
              designed to assist individuals in crafting a comprehensive life
              plan while fostering connections with like-minded people.
            </h6>
            <h6 className="mt-3">
              <b>Technology Stack:</b>
            </h6>
            <h6>
              <b>Backend:</b> Django Rest Framework
            </h6>
            <h6>
              <b>Frontend:</b> Bootstrap, React
            </h6>
            <h6>
              <b>Authentication:</b> JWT
            </h6>
            <h6>
              <b>Database:</b> PostgreSQL
            </h6>
          </Modal.Body>
        </Modal>

        {/* ---------------------- Task Manager Video ---------------------- */}
        <Modal size="lg" show={show4} onHide={handleClose4} centered>
          <Modal.Header closeButton>
            <Modal.Title className="proj-video">Task Management</Modal.Title>
          </Modal.Header>
          <Modal.Body className="myVideo">
            <YouTube videoId="dsb7g0_85Q8" className="project-youtube" />
          </Modal.Body>
        </Modal>

        {/* ---------------------- Task Manager Tech ---------------------- */}
        <Modal show={show5} onHide={handleClose5} centered>
          <Modal.Header closeButton>
            <Modal.Title>Task Management</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <b>Description:</b> Task Manager is an application designed to
              streamline task management for both individual users and groups.
            </h6>
            <h6 className="mt-3">
              <b>Technology Stack:</b>
            </h6>
            <h6>
              <b>Backend:</b> Django Rest Framework
            </h6>
            <h6>
              <b>Authentication:</b> Django-allauth, OAuth2,
              @react-oauth/google
            </h6>
            <h6>
              <b>Frontend:</b> Bootstrap, React
            </h6>
            <h6>
              <b>Database:</b> PostgreSQL
            </h6>
          </Modal.Body>
        </Modal>

        {/* ---------------------- OrganisedSearch Video ---------------------- */}
        <Modal size="lg" show={show6} onHide={handleClose6} centered>
          <Modal.Header closeButton>
            <Modal.Title className="proj-video">OrganisedSearch</Modal.Title>
          </Modal.Header>
          <Modal.Body className="myVideo">
            <YouTube videoId="YhzS7OeZtlg" className="project-youtube" />
          </Modal.Body>
        </Modal>

        {/* ---------------------- OrganisedSearch Tech ---------------------- */}
        <Modal show={show7} onHide={handleClose7} centered>
          <Modal.Header closeButton>
            <Modal.Title>OrganisedSearch</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <b>Description:</b> OrganisedSearch is an AI-powered web
              application that centralizes document storage, offers advanced
              search functionality, and utilizes AI models to provide answers
              based on document content.
            </h6>
            <h6 className="mt-3">
              <b>Technology Stack:</b>
            </h6>
            <h6>
              <b>Backend:</b> Django Rest Framework
            </h6>
            <h6>
              <b>Frontend:</b> React, Material UI
            </h6>
            <h6>
              <b>Authentication:</b> JWT Token
            </h6>
            <h6>
              <b>Database:</b> PostgreSQL
            </h6>
            <h6>
              <b>Models:</b> distilbert-base-cased-distilled-squad,
              microsoft/DialoGPT-medium
            </h6>
          </Modal.Body>
        </Modal>

        {/* ---------------------- Niyam Video ---------------------- */}
        <Modal size="lg" show={showNiyam} onHide={handleCloseNiyam} centered>
          <Modal.Header closeButton>
            <Modal.Title className="proj-video">Niyam</Modal.Title>
          </Modal.Header>
          <Modal.Body className="myVideo">
            <YouTube videoId="sssz19Nm0Eg" className="project-youtube" />
          </Modal.Body>
        </Modal>

        {/* ---------------------- Niyam Tech ---------------------- */}
        <Modal show={showNiyamTech} onHide={handleCloseNiyamTech} centered>
          <Modal.Header closeButton>
            <Modal.Title>Niyam</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <b>Backend:</b> Django + DRF, SimpleJWT, OAuth Toolkit
            </h6>
            <h6>
              <b>Database:</b> PostgreSQL (psycopg2)
            </h6>
            <h6>
              <b>AI/ML:</b> PyTorch + Transformers
            </h6>
            <h6>
              <b>Frontend:</b> React Native (Expo + TypeScript)
            </h6>
            <h6>
              <b>Key Packages:</b> expo, react-native, nativewind, moti
            </h6>
            <h6>
              <b>Auth & Storage:</b> Secure Store, Keychain
            </h6>
            <h6>
              <b>Styling:</b> Tailwind for RN (nativewind)
            </h6>
            <h6>
              <b>Media Handling:</b> Audio, Image Picker
            </h6>
            <h6>
              <b>APIs & Integrations:</b> SerpAPI, TMDB API, Hugging Face
              Transformers
            </h6>
          </Modal.Body>
        </Modal>

        {/* ---------------------- AI Creator Studio Video ---------------------- */}
        <Modal size="lg" show={showCPE} onHide={handleCloseCPE} centered>
          <Modal.Header closeButton>
            <Modal.Title className="proj-video">AI Creator Studio</Modal.Title>
          </Modal.Header>
          <Modal.Body className="myVideo">
            <YouTube videoId="ms4jUqn2d9M" className="project-youtube" />
          </Modal.Body>
        </Modal>

        {/* ---------------------- AI Creator Studio Tech ---------------------- */}
        <Modal show={showCPETech} onHide={handleCloseCPETech} centered>
          <Modal.Header closeButton>
            <Modal.Title>AI Creator Studio</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <b>Backend:</b> Django, Django REST Framework, CORS
            </h6>
            <h6>
              <b>Database:</b> SQLite, PostgreSQL (optional), psycopg2
            </h6>
            <h6>
              <b>AI:</b> Ollama, Llama 3
            </h6>
            <h6>
              <b>Frontend:</b> Next.js, TypeScript, Tailwind CSS
            </h6>
            <h6>
              <b>HTTP:</b> axios, requests
            </h6>
            <h6>
              <b>Utilities:</b> JSON repair/validation pipeline,
              ast.literal_eval
            </h6>
          </Modal.Body>
        </Modal>

        {/* ---------------------- Creative Storyteller Video ---------------------- */}
        <Modal
          size="lg"
          show={showStoryteller}
          onHide={handleCloseStoryteller}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title className="proj-video">Creative Storyteller</Modal.Title>
          </Modal.Header>
          <Modal.Body className="myVideo">
            <YouTube videoId="P4COjdddRg8" className="project-youtube" />
          </Modal.Body>
        </Modal>

        {/* ---------------------- AI Code Explainer Video ---------------------- */}
        <Modal
          size="lg"
          show={showAIExplainer}
          onHide={handleCloseAIExplainer}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title className="proj-video">AI Code Explainer</Modal.Title>
          </Modal.Header>
          <Modal.Body className="myVideo">
            <YouTube videoId="N75Tvad5mcI" className="project-youtube" />
          </Modal.Body>
        </Modal>

        {/* ---------------------- Capital Market AI Video ---------------------- */}
        <Modal
          size="lg"
          show={showCapitalAI}
          onHide={handleCloseCapitalAI}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title className="proj-video">Capital Market AI</Modal.Title>
          </Modal.Header>
          <Modal.Body className="myVideo">
            <YouTube videoId="J0oM_45SV9k" className="project-youtube" />
          </Modal.Body>
        </Modal>

        {/* ---------------------- Creative Storyteller Tech ---------------------- */}
        <Modal
          show={showStorytellerTech}
          onHide={handleCloseStorytellerTech}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Creative Storyteller</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <b>Description:</b> Creative Storyteller is a multimodal AI
              storytelling platform that transforms a simple idea into a
              cinematic story with AI-generated scenes, visuals, and narration.
            </h6>
            <h6 className="mt-3">
              <b>Frontend:</b> Next.js, React, TypeScript, Tailwind CSS, Vercel
            </h6>
            <h6>
              <b>Backend:</b> Python, Django, Django REST Framework, Docker
            </h6>
            <h6>
              <b>AI / Cloud Services:</b> Google Gemini via Vertex AI, Vertex AI
              Image Generation, Google Cloud Text-to-Speech, Google Cloud
              Storage, Google Cloud Run
            </h6>
            <h6>
              <b>Architecture:</b> Next.js frontend → Django REST API on Cloud
              Run → Gemini via Vertex AI → scene generation pipeline → image
              generation + narration audio → Cloud Storage → frontend cinematic
              playback
            </h6>
          </Modal.Body>
        </Modal>

        {/* ---------------------- AI Code Explainer Tech ---------------------- */}
        <Modal
          show={showAIExplainerTech}
          onHide={handleCloseAIExplainerTech}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>AI Code Explainer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <b>Description:</b> AI-powered tool to explain, debug, and compare
              code using multiple LLMs in real-time.
            </h6>

            <h6 className="mt-3">
              <b>Technology Stack:</b>
            </h6>

            <h6>
              <b>Frontend:</b> React
            </h6>
            <h6>
              <b>Backend:</b> Express.js (Node.js)
            </h6>
            <h6>
              <b>AI Models:</b> Ollama (CodeLlama, DeepSeek, Mistral)
            </h6>
            <h6>
              <b>Features:</b> Streaming API, Rate Limiting, Helmet, CORS
            </h6>

            <h6 className="mt-3">
              <b>Architecture:</b> React → Express → Multiple LLMs → Parallel
              Execution → Comparison Dashboard
            </h6>
          </Modal.Body>
        </Modal>

        {/* ---------------------- Wexa Analytics Tech ---------------------- */}
        <Modal show={showWexaTech} onHide={handleCloseWexaTech} centered>
          <Modal.Header closeButton>
            <Modal.Title>Wexa Analytics Platform</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <b>Description:</b> Wexa Analytics Platform is a production-style
              SaaS analytics and reporting system for real-time dashboards,
              event ingestion, alerts, reports, and live operational monitoring.
            </h6>
            <h6 className="mt-3">
              <b>Frontend:</b> Next.js, TypeScript, Tailwind CSS, Recharts,
              Axios
            </h6>
            <h6>
              <b>Backend:</b> Django, Django REST Framework, Django Channels
            </h6>
            <h6>
              <b>Database:</b> PostgreSQL / SQLite for demo
            </h6>
            <h6>
              <b>Async / Real-Time:</b> Redis, Celery, Celery Beat, WebSockets
            </h6>
            <h6>
              <b>Authentication:</b> JWT, API Keys, RBAC, Organization-level
              data isolation
            </h6>
            <h6>
              <b>Deployment:</b> Vercel frontend, Render backend, Render Key
              Value for Redis
            </h6>
            <h6>
              <b>Architecture:</b> Next.js → Django REST API → Redis/Celery →
              Django Channels WebSockets → Live dashboards and alerts
            </h6>
          </Modal.Body>
        </Modal>

        {/* ---------------------- Capital Market AI Tech ---------------------- */}
        <Modal
          show={showCapitalAITech}
          onHide={handleCloseCapitalAITech}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Capital Market AI</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              <b>Description:</b> Capital Market AI is an AI-powered settlement
              failure investigation platform built for Microsoft Build AI
              Hackathon 2026 under the Agentic Web / Orchestrate Actions Across
              Services theme.
            </h6>
            <h6 className="mt-3">
              <b>Frontend:</b> Next.js, React, TypeScript, Tailwind CSS, Vercel
            </h6>
            <h6>
              <b>Backend:</b> Python, Django, Django REST Framework
            </h6>
            <h6>
              <b>AI:</b> Azure OpenAI, Semantic Kernel, Agentic AI workflows
            </h6>
            <h6>
              <b>Cloud:</b> Azure App Service, Azure Blob Storage, Azure
              SQL-ready architecture, Azure AI Foundry-ready
            </h6>
            <h6>
              <b>Capital Markets:</b> SWIFT MT544, MT545, MT546, MT547,
              settlement failures, SSI validation, cash checks, securities
              checks
            </h6>
            <h6>
              <b>Workflow:</b> Upload → Parse → Investigate → RCA → Action
              Orchestration → Audit
            </h6>
            <h6>
              <b>Note:</b> Sample trade and SWIFT data is synthetic and used
              only for testing/demo.
            </h6>
          </Modal.Body>
        </Modal>

        {/* ---------------------- Unravel Card ---------------------- */}
        <Card style={{ width: "25rem" }} className="project mx-2 my-2">
          <div className="project-image-stack">
            <Card.Img variant="top" src="../images/un1.png" />
          </div>
          <Card.Body className="project-body">
            <div>
              <Card.Title>Unravel</Card.Title>

              <div className="project-tags">
                <span>Django</span>
                <span>DRF</span>
                <span>Bootstrap</span>
                <span>JavaScript</span>
              </div>

              <Card.Text>
                <ul>
                  <li>Built a social media platform for interest-based communities.</li>
                  <li>Implemented posts, comments, friendships, and messaging.</li>
                  <li>Focused on collaboration and community engagement features.</li>
                </ul>
              </Card.Text>
            </div>

            <div className="project-actions">
              <Button variant="primary" onClick={handleShow}>
                Demo
              </Button>
              <Button variant="secondary" onClick={handleShow2}>
                Tech Stack
              </Button>
            </div>
          </Card.Body>
          <Card.Footer className="text-muted">
            <b>Time:</b> 2022
          </Card.Footer>
        </Card>

        {/* ---------------------- Connect Card ---------------------- */}
        <Card style={{ width: "25rem" }} className="project mx-2 my-2">
          <div className="project-image-stack">
            <Card.Img variant="top" src="../images/cn2.png" />
          </div>
          <Card.Body className="project-body">
            <div>
              <Card.Title>Connect</Card.Title>

              <div className="project-tags">
                <span>React</span>
                <span>DRF</span>
                <span>PostgreSQL</span>
                <span>JWT</span>
              </div>

              <Card.Text>
                <ul>
                  <li>Built a social platform for life planning and meaningful connections.</li>
                  <li>Added profile customization, login, registration, and messaging.</li>
                  <li>Enabled users to manage plans across multiple life areas.</li>
                </ul>
              </Card.Text>
            </div>

            <div className="project-actions">
              <Button variant="primary" onClick={handleShow1}>
                Demo
              </Button>
              <Button variant="secondary" onClick={handleShow3}>
                Tech Stack
              </Button>
            </div>
          </Card.Body>
          <Card.Footer className="text-muted">
            <b>Time:</b> 2023
          </Card.Footer>
        </Card>

        {/* ---------------------- Task Manager Card ---------------------- */}
        <Card style={{ width: "25rem" }} className="project mx-2 my-2">
          <div className="project-image-stack">
            <Card.Img variant="top" src="../images/Task_manager.png" />
          </div>
          <Card.Body className="project-body">
            <div>
              <Card.Title>Task Manager</Card.Title>

              <div className="project-tags">
                <span>React</span>
                <span>DRF</span>
                <span>OAuth2</span>
                <span>PostgreSQL</span>
              </div>

              <Card.Text>
                <ul>
                  <li>Built a task management app for individuals and teams.</li>
                  <li>Created REST APIs for seamless frontend-backend communication.</li>
                  <li>Integrated authentication using OAuth2 and Google login.</li>
                </ul>
              </Card.Text>
            </div>

            <div className="project-actions">
              <Button variant="primary" onClick={handleShow4}>
                Demo
              </Button>
              <Button variant="secondary" onClick={handleShow5}>
                Tech Stack
              </Button>
            </div>
          </Card.Body>
          <Card.Footer className="text-muted">
            <b>Time:</b> 2024
          </Card.Footer>
        </Card>

        {/* ---------------------- OrganisedSearch Card ---------------------- */}
        <Card style={{ width: "25rem" }} className="project mx-2 my-2">
          <div className="project-image-stack">
            <Card.Img variant="top" src="../images/OrganizedSearch.png" />
          </div>
          <Card.Body className="project-body">
            <div>
              <Card.Title>OrganisedSearch</Card.Title>

              <div className="project-tags">
                <span>React</span>
                <span>DRF</span>
                <span>AI Search</span>
                <span>PostgreSQL</span>
              </div>

              <Card.Text>
                <ul>
                  <li>Built an AI-powered search platform for stored documents.</li>
                  <li>Added question answering and chatbot capabilities.</li>
                  <li>Used modern UI with React and Material UI.</li>
                </ul>
              </Card.Text>
            </div>

            <div className="project-actions">
              <Button variant="primary" onClick={handleShow6}>
                Demo
              </Button>
              <Button variant="secondary" onClick={handleShow7}>
                Tech Stack
              </Button>
            </div>
          </Card.Body>
          <Card.Footer className="text-muted">
            <b>Time:</b> 2025
          </Card.Footer>
        </Card>

        {/* ---------------------- Niyam Card ---------------------- */}
        <Card
          style={{ width: "25rem" }}
          className="project featured-project mx-2 my-2"
        >
          <div className="project-image-stack">
            <Card.Img variant="top" src="../images/Niyam.png" />
          </div>
          <Card.Body className="project-body">
            <div>
              <Card.Title>Niyam</Card.Title>

              <div className="project-tags">
                <span>React Native</span>
                <span>Django</span>
                <span>PyTorch</span>
                <span>Expo</span>
              </div>

              <Card.Text>
                <ul>
                  <li>
                    Built a holistic personal growth app with meditation, blogs,
                    films, and audiobooks.
                  </li>
                  <li>Implemented authentication, profile management, and backend APIs.</li>
                  <li>Added AI-powered recommendations and personality-based features.</li>
                </ul>
              </Card.Text>
            </div>

            <div className="project-actions">
              <Button variant="primary" onClick={handleShowNiyam}>
                Demo
              </Button>
              <Button variant="secondary" onClick={handleShowNiyamTech}>
                Tech Stack
              </Button>
            </div>
          </Card.Body>
          <Card.Footer className="text-muted">
            <b>Time:</b> 2025
          </Card.Footer>
        </Card>

        {/* ---------------------- AI Creator Studio Card ---------------------- */}
        <Card
          style={{ width: "25rem" }}
          className="project featured-project mx-2 my-2"
        >
          <div className="project-image-stack">
            <Card.Img variant="top" src="../images/ProductionEngine.png" />
          </div>
          <Card.Body className="project-body">
            <div>
              <Card.Title>AI Creator Studio</Card.Title>

              <div className="project-tags">
                <span>Next.js</span>
                <span>Django</span>
                <span>Ollama</span>
                <span>Tailwind</span>
              </div>

              <Card.Text>
                <ul>
                  <li>
                    Built an end-to-end content factory from topic to
                    publish-ready asset bundle.
                  </li>
                  <li>Added production-grade JSON reliability for broken LLM responses.</li>
                  <li>Implemented per-section regeneration and history for fast iteration.</li>
                </ul>
              </Card.Text>
            </div>

            <div className="project-actions">
              <Button variant="primary" onClick={handleShowCPE}>
                Demo
              </Button>
              <Button variant="secondary" onClick={handleShowCPETech}>
                Tech Stack
              </Button>
            </div>
          </Card.Body>
          <Card.Footer className="text-muted">
            <b>Time:</b> 2026
          </Card.Footer>
        </Card>

        {/* ---------------------- Creative Storyteller Card ---------------------- */}
        <Card
          style={{ width: "25rem" }}
          className="project featured-project mx-2 my-2"
        >
          <div className="project-image-stack">
            <Card.Img variant="top" src="../images/CreativeStoryteller.png" />
          </div>
          <Card.Body className="project-body">
            <div>
              <Card.Title>Creative Storyteller</Card.Title>

              <div className="project-tags">
                <span>Next.js</span>
                <span>Django</span>
                <span>Gemini</span>
                <span>Google Cloud</span>
              </div>

              <Card.Text>
                <ul>
                  <li>
                    Built a multimodal AI storytelling platform for cinematic
                    story generation.
                  </li>
                  <li>
                    Orchestrated text, images, and narration through a
                    Django-based agent pipeline.
                  </li>
                  <li>
                    Integrated Vertex AI, Cloud Run, Cloud Storage, and
                    Text-to-Speech.
                  </li>
                </ul>
              </Card.Text>
            </div>

            <div className="project-actions">
              <Button variant="primary" onClick={handleShowStoryteller}>
                Demo
              </Button>
              <Button variant="secondary" onClick={handleShowStorytellerTech}>
                Tech Stack
              </Button>
            </div>
          </Card.Body>
          <Card.Footer className="text-muted">
            <b>Time:</b> 2026
          </Card.Footer>
        </Card>

        {/* ---------------------- AI Code Explainer Card ---------------------- */}
        <Card
          style={{ width: "25rem" }}
          className="project featured-project mx-2 my-2"
        >
          <div className="project-image-stack">
            <Card.Img variant="top" src="../images/AIExplainer.png" />
          </div>

          <Card.Body className="project-body">
            <div>
              <Card.Title>AI Code Explainer</Card.Title>

              <div className="project-tags">
                <span>React</span>
                <span>Express</span>
                <span>Ollama</span>
                <span>LLMs</span>
              </div>

              <Card.Text>
                <ul>
                  <li>Built a multi-model AI system to explain and debug code.</li>
                  <li>Ran CodeLlama, DeepSeek & Mistral in parallel.</li>
                  <li>Compared speed, accuracy & response quality in real-time.</li>
                  <li>Implemented auto bug detection & correction engine.</li>
                  <li>Designed like a real-world ML pipeline system.</li>
                </ul>
              </Card.Text>
            </div>

            <div className="project-actions">
              <Button variant="primary" onClick={handleShowAIExplainer}>
                Demo
              </Button>
              <Button variant="secondary" onClick={handleShowAIExplainerTech}>
                Tech Stack
              </Button>
            </div>
          </Card.Body>

          <Card.Footer className="text-muted">
            <b>Time:</b> 2026
          </Card.Footer>
        </Card>

        {/* ---------------------- Wexa Analytics Platform Card ---------------------- */}
        <Card
          style={{ width: "25rem" }}
          className="project featured-project mx-2 my-2"
        >
          <div className="project-image-stack">
            <Card.Img variant="top" src="../images/WexaAnalytics.png" />
          </div>

          <Card.Body className="project-body">
            <div>
              <Card.Title>Wexa Analytics Platform</Card.Title>

              <div className="project-tags">
                <span>Django</span>
                <span>Next.js</span>
                <span>Redis</span>
                <span>WebSockets</span>
              </div>

              <Card.Text>
                <ul>
                  <li>
                    Built a real-time multi-tenant analytics platform for live
                    dashboards and event streaming.
                  </li>
                  <li>
                    Developed ingestion pipelines supporting single events,
                    batch APIs, CSV uploads, webhooks, and API-key access.
                  </li>
                  <li>
                    Implemented KPI dashboards, alerts, RBAC, Celery workflows,
                    Redis, and WebSocket updates.
                  </li>
                </ul>
              </Card.Text>
            </div>

            <div className="project-actions">
              {/* <Button
                variant="primary"
                onClick={() =>
                  window.open(
                    "https://wexa-aidash-frontend-ab2.vercel.app",
                    "_blank"
                  )
                }
              >
                Live Demo
              </Button> */}
              {/* <Button
                variant="outline-primary"
                onClick={() =>
                  window.open("https://wexaaidashboard-1.onrender.com", "_blank")
                }
              >
                API
              </Button> */}
              <Button variant="secondary" onClick={handleShowWexaTech}>
                Tech Stack
              </Button>
            </div>
          </Card.Body>

          <Card.Footer className="text-muted">
            <b>Time:</b> 2026
          </Card.Footer>
        </Card>

        {/* ---------------------- Capital Market AI Card ---------------------- */}
        <Card
          style={{ width: "25rem" }}
          className="project featured-project mx-2 my-2"
        >
          <div className="project-image-stack">
            <Card.Img variant="top" src="../images/CapitalMarketAI.png" />
          </div>

          <Card.Body className="project-body">
            <div>
              <Card.Title>Capital Market AI</Card.Title>

              <div className="project-tags">
                <span>Azure OpenAI</span>
                <span>Semantic Kernel</span>
                <span>Django</span>
                <span>Next.js</span>
              </div>

              <Card.Text>
                <ul>
                  <li>
                    Built an AI-powered settlement failure investigation
                    platform for capital markets post-trade workflows.
                  </li>
                  <li>
                    Parsed SWIFT confirmations and validated SSI, cash balances,
                    securities holdings, and settlement states.
                  </li>
                  <li>
                    Generated RCA, Jira/Teams/Email action previews, alerts,
                    timelines, and audit trails using agentic workflows.
                  </li>
                </ul>
              </Card.Text>
            </div>

            <div className="project-actions">
              <Button variant="primary" onClick={handleShowCapitalAI}>
                Demo
              </Button>
              {/* <Button
                variant="outline-primary"
                onClick={() =>
                  window.open(
                    "https://capital-market-ai-frontend-6d7q.vercel.app",
                    "_blank"
                  )
                }
              >
                Live Demo
              </Button> */}
              <Button variant="secondary" onClick={handleShowCapitalAITech}>
                Tech Stack
              </Button>
            </div>
          </Card.Body>

          <Card.Footer className="text-muted">
            <b>Time:</b> 2026
          </Card.Footer>
        </Card>
      </div>
    </div>
  );
}

export default MyProjects;